<section class="container-fluid min-height-container bg-white pb-5">
    <section class="container pt-5">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <h1 class="text-center mt-5">
                        Example of Potential Savings
                    </h1>
                    <h4 class="text-center mt-2 mb-5 text-danger">
                        (Savings vary from provider to provider)
                    </h4>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <h3 class="text-center">New Patient Visit</h3>
                    <table class="mx-auto table">
                        <tr>
                            <th>Service Type</th>
                            <th class="text-center">Actual Fee</th>
                            <th class="text-center">Discounted Fee</th>
                        </tr>
                        <tr>
                            <td colspan="2">Family Health Advantage Membership</td>
                            <td class="text-center">$39</td>
                        </tr>
                        <tr>
                            <td>New Patient Exam</td>
                            <td class="text-center">$100</td>
                            <td class="text-center">$50</td>
                        </tr>
                        <tr>
                            <td>Adjustment</td>
                            <td class="text-center">$60</td>
                            <td class="text-center">$45</td>
                        </tr>
                        <tr>
                            <td>Therapy</td>
                            <td class="text-center">$20</td>
                            <td class="text-center">$15</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td class="text-center">Without Family Health Advantage<br><span class="text-danger bg-transparent fs-3">$180</span></td>
                            <td class="text-center">With Family Health Advantage<br><span class="text-success bg-transparent fs-3">$149*</span></td>
                        </tr>
                    </table>
                    <h4>
                        *Total Savings (minus $39 membership) <span class="text-success">$70 or a 39% savings</span>
                    </h4>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <h3 class="text-center">Routine Patient Visit</h3>
                    <table class="mx-auto table">
                        <tr>
                            <th>Service Type</th>
                            <th class="text-center">Actual Fee</th>
                            <th class="text-center">Discounted Fee</th>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr><td>&nbsp;</td></tr>

                        <tr>
                            <td>Adjustment</td>
                            <td class="text-center">$60</td>
                            <td class="text-center">$45</td>
                        </tr>
                        <tr>
                            <td>Therapy</td>
                            <td class="text-center">$20</td>
                            <td class="text-center">$15</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td class="text-center">Without Family Health Advantage<br><span class="text-danger bg-transparent fs-3">$80</span></td>
                            <td class="text-center">With Family Health Advantage<br><span class="text-success bg-transparent fs-3">$60*</span></td>
                        </tr>
                    </table>
                    <h4>
                        *Total Savings per routine visit <span class="text-success">$20 or a 25% savings</span>
                    </h4>
                </div>
            </div>
    </section>
</section>